import { Button, Space, Upload } from 'antd';
import { PictureOutlined, UploadOutlined } from '@ant-design/icons';
import { useImagePicker } from './image-picker-context';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * 工具列上的圖片入口：與封面卡同一套用語，帶文字標籤（不只圖示），
 * 記者一眼就找得到「從媒體庫挑選」與「上傳新圖片」。
 * 手機工具列空間有限 → 只留圖示（aria-label 保留完整說明）。
 */
export default function ImageInsertButtons() {
  const picker = useImagePicker();
  const mobile = useIsMobile();
  if (!picker) return null;
  const size = mobile ? 'middle' : 'small';

  return (
    <Space size={4}>
      <Button
        size={size}
        type="primary"
        ghost
        aria-label="從媒體庫挑選圖片"
        icon={<PictureOutlined />}
        onClick={() => picker.openLibrary({ mode: 'insert' })}
      >
        {!mobile && '從媒體庫挑選圖片'}
      </Button>
      <Upload
        multiple
        showUploadList={false}
        accept="image/*"
        beforeUpload={(file) => {
          picker.uploadInsert([file as File]);
          return false;
        }}
      >
        <Button size={size} aria-label="上傳新圖片" icon={<UploadOutlined />}>
          {!mobile && '上傳新圖片'}
        </Button>
      </Upload>
    </Space>
  );
}
